import { createSlice } from '@reduxjs/toolkit';
import { AVAILABLE_BUNDLES } from "../utils/localstore";

const localData = JSON.parse(localStorage.getItem(AVAILABLE_BUNDLES)) ?? null;

const initialState = !!localData ? localData : {
  selectedBundle: null,
  allBundles: []
};

const bundlesSlice = createSlice({
    name: 'bundles',
    initialState,
    reducers: {
      setAllBundles(state, { payload }) {
        localStorage.setItem(AVAILABLE_BUNDLES, JSON.stringify({ ...state, allBundles: payload }));
        state.allBundles = payload;
      },
      setSelectedBundle(state, { payload }) {
        localStorage.setItem(AVAILABLE_BUNDLES, JSON.stringify({ ...state, selectedBundle: payload }));
        state.selectedBundle = payload;
      }
    }
});

export const { setAllBundles, setSelectedBundle } = bundlesSlice.actions;
export default bundlesSlice.reducer;
